const poseMeshSelectionPointerEvents = new WeakSet<Event>();

export function markPoseMeshSelectionPointerEvent(event: Event) {
  poseMeshSelectionPointerEvents.add(event);
}

export function isPoseMeshSelectionPointerEvent(event: Event) {
  return poseMeshSelectionPointerEvents.has(event);
}
